import {
  VectorStyleLayer,
  VectorStyle
} from '../../../layer-type-services/vector-tile/twc-vector-tile.layer';
import { TwcProduct } from '../../../twc-products';

const TWC_AIRMETS_VECTOR_STYLE_LAYERS: VectorStyleLayer[] = [
  {
    layout: {},
    paint: {
      'fill-color': '#0081B7',
      'fill-outline-color': '#0081B7',
      'fill-opacity': 0.2
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ice',
    filter: ['==', 'type', 'ICE'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: {
      'fill-color': '#FF7F00',
      'fill-outline-color': '#FF7F00',
      'fill-opacity': 0.2
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'turb',
    filter: ['==', 'type', 'TURB'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: {
      'fill-color': '#1A6500',
      'fill-outline-color': '#1A6500',
      'fill-opacity': 0.2
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'winds',
    filter: ['==', 'type', 'WINDS'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: {
      'fill-color': '#8700FF',
      'fill-outline-color': '#8700FF',
      'fill-opacity': 0.2
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ifr',
    filter: ['==', 'type', 'IFR'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: {
      'fill-color': '#FE11FC',
      'fill-outline-color': '#FE11FC',
      'fill-opacity': 0.2
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'mt-obsc',
    filter: ['==', 'type', 'MT OBSC'],
    type: 'fill',
    maxzoom: 28
  },
  {
    layout: {},
    paint: {
      'fill-color': '#C95300',
      'fill-outline-color': '#C95300',
      'fill-opacity': 0.2
    },
    source: 'twc',
    minzoom: 0,
    'source-layer': 'source-layer',
    id: 'ws',
    filter: ['==', 'type', 'WS'],
    type: 'fill',
    maxzoom: 28
  }
];

export const TWC_AIRMETS_VECTOR_STYLE: VectorStyle = {
  layers: TWC_AIRMETS_VECTOR_STYLE_LAYERS
};

export const AIRMETS_PRODUCT_DATA: TwcProduct = {
  id: 'airmets',
  defaultProductId: '6002-boeing',
  productName: 'Weather-AIRMETS-TWC',
  label: 'AIRMETs',
  weatherType: 'AIRMET',
  description: 'TWC product (vector) - Government AIRMETs',
  series: 'Observation',
  timeSlicePeriodInMinutes: 5,
  lodMax: 0,
  protocol: 'VectorTile',
  forecastTimeSlicePeriod: 0,
  flightLevelProductIds: {},
  zOrder: 90,
  layerSpecs: {
    vectorTile: { vectorStyle: TWC_AIRMETS_VECTOR_STYLE }
  }
};
